import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import KogInputAutoCompleteCheckControlled from '@/main/components/shared/inputAutoCompleteCheck/inputAutoCompleteCheckControlled';
import { isNullUndefined } from '@/main/services/utils';
import { getSubModels, resetReducerSubModels, useSubModelReducer } from '@/main/store/vehicle/subModel';
import { GeneralVariableType, useDynamicFiltersExport } from './dynamicFiltersExport';

interface IVariableTypeSubModelProps extends GeneralVariableType { }
function VariableTypeSubModel({
  filter
}: IVariableTypeSubModelProps) {
  const dispatch = useDispatch();
  const {
    keyReducer,
    findFieldIndexByGuidDynamicReportVariable,
    idScreen,
    watcherCountry
  } = useDynamicFiltersExport();
  const { isolated: subModelsReducer } = useSubModelReducer(keyReducer);
  const {
    control,
  } = useFormContext();

  useEffect(() => {
    if (isNullUndefined(watcherCountry)) return;

    dispatch(
      getSubModels(
        {
          guidCountry: String(watcherCountry?.key)
        },
        keyReducer
      )
    );

    return () => {
      dispatch(resetReducerSubModels(keyReducer));
    }
  }, [JSON.stringify(watcherCountry?.key)])

  const disabledSubModel = isNullUndefined(subModelsReducer.data) || subModelsReducer.data.length === 1
  const indexField = findFieldIndexByGuidDynamicReportVariable(filter.guidDynamicReportVariable);

  return (
    <>
      <KogInputAutoCompleteCheckControlled
        name={`filtersDinamics.${indexField}.value`}
        disableSelectAll
        control={control}
        options={subModelsReducer.data || []}
        label={filter.responseServer.filterName}
        disabled={disabledSubModel}
        isLoading={subModelsReducer.isLoading}
        controllerProps={{ rules: { required: filter.responseServer.mandatory } }}
        customInputProps={{ required: filter.responseServer.mandatory, id: idScreen('select-model') }}
        onChangeCustom={(value, optionChanged, reason) => { }}
      />
    </>
  )
}

export default VariableTypeSubModel